module.exports = __webpack_public_path__ + "img/stock1.43db1ea2.png";